import ToolTip from './tooltip'

export default ToolTip
